$(document).ready(function () {
  var currentMax = ~~max_value;
  var currentMin = 0;

  var url = new URL(window.location.href);
  var params = url.searchParams;

  if (params.has("filter.v.price.lte")) {
    currentMax = ~~params.get("filter.v.price.lte");
  }

  if (params.has("filter.v.price.gte")) {
    currentMin = ~~params.get("filter.v.price.gte");
    $("#price-header").html(
      `Price ${currency}${~~params.get(
        "filter.v.price.gte"
      )} - ${currency}${~~params.get("filter.v.price.lte")}`
    );
  }

  var slider = document.getElementById("slider");
  noUiSlider.create(slider, {
    start: [currentMin, currentMax],
    connect: true,
    range: {
      min: 0,
      max: ~~max_value,
    },
    step: 1,
  });

  slider.noUiSlider.on("slide", function () {
    $("#price-header").html(
      `Price ${currency}${slider.noUiSlider
        .get()[0]
        .replace(".00", "")} - ${currency}${slider.noUiSlider
        .get()[1]
        .replace(".00", "")}`
    );
    var url = new URL(window.location.href);
    var params = new URLSearchParams(url.search);
  });

  $(".ui-slider-handle:eq(0)").append(
    '<span class="price-range-min value">0</span>'
  );

  $(".ui-slider-handle:eq(1)").append(
    `<span class="price-range-max value">${currentMax}</span>`
  );

  $(".mobile-facets__footer button").on("click", function (e) {
    var url = new URL(window.location.href);
    var params = url.searchParams;

    if (params.has("filter.v.price.lte")) {
      params.set("filter.v.price.lte", slider.noUiSlider.get()[1]);
    } else {
      params.append("filter.v.price.lte", slider.noUiSlider.get()[1]);
    }

    if (params.has("filter.v.price.gte")) {
      params.set("filter.v.price.gte", slider.noUiSlider.get()[0]);
    } else {
      params.append("filter.v.price.gte", slider.noUiSlider.get()[0]);
    }

    window.location.replace(url["href"]);
  });
});
